var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.883,
    cy: 18.24,
    r: 1.399
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M37.993 5.16l-12.72 32.2-6.72-12.92-13.28-6.52zM18.553 24.44l19.44-19.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.769 35.453l6.44-6.441M13.721 37.149l2.717-2.718M4.526 30.776l3.968-3.968"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.07ffff8664fc8eea8d5b90dde56a7b46.svg";
export { ForwardRef as ReactComponent };